import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    carousel:
      'w-full [--slide-size:auto] [--slide-spacing:16px] md:[--slide-spacing:0]',
    viewport:
      'px-[calc(50%-var(--screen-max-width)/2+var(--spacing)*4)] pt-1.5',
    controls: 'pointer-events-none absolute inset-0 max-sm:hidden 2xl:hidden',
    controlsContainer: 'container h-full',
    controlsInner: 'relative h-full',
    button: 'w-full max-md:w-[124px]! max-md:max-w-none!'
  }
});
